import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ProductJpkVatGroupCollectionQuery, ProductJpkVatGroupCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductJpkVatGroupCollectionQuery)
@Wrapper(ProductJpkVatGroupCollectionQueryHandlerBase)
export class ProductJpkVatGroupCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
